const configuredApiBaseUrl = process.env.NEXT_PUBLIC_API_BASE_URL?.trim();

if (!configuredApiBaseUrl && process.env.NODE_ENV === 'production') {
  throw new Error('NEXT_PUBLIC_API_BASE_URL must be configured in production');
}

export const API_BASE_URL = configuredApiBaseUrl ?? 'http://localhost:8080/api';

export const DASHBOARD_APP_URL =
  process.env.NEXT_PUBLIC_DASHBOARD_APP_URL ?? 'http://localhost:3001';

export const DASHBOARD_AUTH_REDIRECT_PATH =
  process.env.NEXT_PUBLIC_DASHBOARD_AUTH_REDIRECT_PATH ?? '/login';

export const CLERK_ALLOWED_REDIRECT_ORIGINS = [
  'http://localhost:3001',
  'http://localhost:3002',
  ...(process.env.NEXT_PUBLIC_CLERK_ALLOWED_REDIRECT_ORIGINS ?? '')
    .split(',')
    .flatMap((origin) => {
      const trimmedOrigin = origin.trim();

      return trimmedOrigin ? [trimmedOrigin] : [];
    })
];
